var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMulti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9753",
    "data-name": "Rectangle 9753",
    width: 83,
    height: 83,
    transform: "translate(-23701 -21820)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(23701 21820)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(-99 -44.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(-23602 -21775.529)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 39.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(-23588.857 -21762.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M203.934,151.875H190.481v-31.39h31.391v13.452h2.883V117.6H187.6v37.156h16.334Z",
    transform: "translate(-187.599 -117.603)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M298.732,386.722v-6.794l-.711-1.259-2.171.548V389.6h8.35l-1.624-2.882Z",
    transform: "translate(-277.276 -333.876)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M369.792,225.848v2.883h13.452v31.39H359.991L359.973,263h26.154V225.848Z",
    transform: "translate(-330.396 -207.275)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M313.217,243.217V224H294v16.575l11.569-11.165-.106,13.808Z",
    transform: "translate(-275.743 -205.744)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M226.49,144.589A1.316,1.316,0,0,0,225.154,146a1.3,1.3,0,0,0,1.336,1.4,1.412,1.412,0,0,0,0-2.815Z",
    transform: "translate(-218.706 -139.958)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M226.949,171.7l-.317,10.9H228.8l-.317-10.9Z",
    transform: "translate(-219.934 -162.418)",
    fill: "#1dcc1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M257.275,296.472l5.966,10.56.192-24.9-17.93,17.3Z",
    transform: "translate(-235.568 -253.898)",
    fill: "#1dcc1d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/multi.0e00cf84d01a44cda0122b2ccc95ead0.svg";
export { ForwardRef as ReactComponent };